/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyWalletAIcon20Solid = forwardRef('MoneyWalletAIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M1 5.5A3.5 3.5 0 0 1 4.5 2h8a3.5 3.5 0 0 1 3.163 2H4.75a.75.75 0 0 0 0 1.5h11.554a3.502 3.502 0 0 1 1.661 2.506A1.166 1.166 0 0 0 17.85 8H13a3 3 0 1 0 0 6h4.85c.05 0 .1-.003.15-.01v.51a3.5 3.5 0 0 1-3.5 3.5h-10A3.5 3.5 0 0 1 1 14.5v-9Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 9.15a.15.15 0 0 0-.15-.15H13a2 2 0 1 0 0 4h4.85a.15.15 0 0 0 .15-.15v-3.7ZM15 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" })));
});
